let currentVersion: string | null = null;

export async function checkAppVersion(): Promise<boolean> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    const { version: newVersion } = await res.json();

    if (!currentVersion) {
      currentVersion = newVersion;
      return false;
    }

    if (newVersion !== currentVersion) {
      return true;
    }

    return false;
  } catch (err) {
    console.error('Failed to check version:', err);
    return false;
  }
}
